export default (theme) => ({
  root: {
    // the popup is rendered into the root, which therefore has to be its containing block
    position: 'relative',
    // stock reveals the ✕ only under `@media (pointer: fine)`, which never matches on touch-capable laptops
    '&:hover $clearIndicatorDirty': {
      visibility: 'visible',
    },
  },
  clearIndicatorDirty: {},
  input: {
    // theme/overrides.js sets the app-wide input padding with !important, so matching it needs one too
    padding: '0.4rem !important',
  },
  // lab centres this with `top: calc(50% - 14px)`, which only holds while the icons make it exactly 28px tall
  endAdornment: {
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    '& .MuiIconButton-root:hover': {
      backgroundColor: theme.palette.background.transparent,
    },
  },
  option: {
    fontSize: 14,
  },
  // the pinned action row must read as a list row, not a floating button
  footer: {
    '& > .MuiButton-root': {
      width: '100%',
      minHeight: 48,
      height: 'auto',
      justifyContent: 'flex-start',
      padding: '6px 16px',
      borderRadius: 0,
      fontSize: 14,
      // the paper spreads body1; MUI's own option row inherits its 1.2, the Button ships 1.75
      lineHeight: 1.2,
      textTransform: 'none',
      [theme.breakpoints.up('sm')]: {
        minHeight: 'auto',
      },
      // six callers force `background: #fff !important` on hover; a row highlight needs equal weight
      '&:hover': {
        backgroundColor: `${theme.palette.action.hover} !important`,
      },
    },
  },
  // the popup is capped to the visible space under the field, so the list scrolls and the footer stays pinned
  paper: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  listbox: {
    maxHeight: 'none',
    flex: '1 1 auto',
    // a flex item refuses to shrink below its content without it, and the cap would do nothing
    minHeight: 0,
  },
  // no rules of their own — they exist as override slots for the `classes` prop
  inputRoot: {},
  popper: {},
});
